module.exports = __webpack_public_path__ + "vue/img/logo7.50adb070.png";